import './App.css';
import {React, useState} from "react"; 
import logo from './c3ColLogo.jpg'; 
import burdenStats from './high.png'; 
import vHigh from './veryHigh.png'; 
import exHigh from './exHigh.png'; 
import axios from 'axios'; 
 
function App() {
 
  
  const [name, setName] = useState(""); 
  const [email, setEmail] = useState(""); 
  const [income, setIncome] = useState(0); 
  const [electricity, setelectricity] = useState(0); 
  const [natGas, setnatGas] = useState(0); 
  const [oFuel, setoFuel] = useState(0); 
  const [monthly, setMonthly] = useState(true); 
  const [monthly1, setMonthly1] = useState(true); 
  const [monthly2, setMonthly2] = useState(true); 
  const [burden, setBurden] = useState(0)
  const [invalidEmail, setinvalidEmail] = useState(""); 
  const [notNum, setnotNum] = useState(""); 
  const [fill, setFill] = useState(""); 

  const changeName = (e) => {
    setName(e.target.value); 
  }; 

  const changeEmail = (e) => {
    setEmail(e.target.value); 
  }; 

  const changeIncome = (e) => {
    setIncome(parseFloat(e.target.value.replace(",", ""))); 
  }; 


  const changeeectricity = (e) => {
    setelectricity(parseFloat(e.target.value.replace(",", ""))); 
  }; 

  const changenatGas = (e) => {
    setnatGas(parseFloat(e.target.value.replace(",", ""))); 
  }; 

  const changeoFuel = (e) => {
    setoFuel(parseFloat(e.target.value.replace(",", ""))); 
  }; 

  const changeMonthly = (e) => {
    if (e.target.value === "Annually")
    setMonthly(false); 
  }; 

  const changeMonthly1 = (e) => {
    if (e.target.value === "Annually")
    setMonthly1(false); 
  }; 

  const changeMonthly2 = (e) => {
    if (e.target.value === "Annually")
    setMonthly2(false); 
  }; 

  function validateEmail(email) 
    {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

  const submitVal = () => {
   // if (validateEmail) {setinvalidEmail(false); } 
   if (!validateEmail(email) | (isNaN(electricity) | isNaN(income) | isNaN(oFuel) | isNaN(natGas))) {
    if (!validateEmail(email)) {
      setinvalidEmail("Please enter a valid email."); 
    }
    if ((isNaN(electricity) | isNaN(income) | isNaN(oFuel) | isNaN(natGas))) {
      setnotNum("Please enter a valid number for energy bill fields."); 
    }
    if (!(name !== "" & email !== "" & income !== 0 & electricity !== 0)) {
      setFill("Please fill out all required fields."); 
    }
   }
    else if (name !== "" & email !== "" & income !== 0 & electricity !== 0) { 
      axios.post('https://sheet.best/api/sheets/ac806c4c-dfd4-4b03-814d-5faa4324abd1', 
      {name:name, email: email})
      .then(response => {
        console.log(response);
      })
      let energy = 0; 
    if (monthly) {
      energy = energy + oFuel*12; 
    }
    if (!monthly) {
      energy = energy + oFuel; 
    }
    if (monthly1) {
      energy = energy + 12*electricity; 
    }
    if (!monthly1) {
      energy = energy + electricity; 
    }
    if (monthly2) {
      energy = energy + 12*natGas; 
    }
    if (!monthly2) {
      energy = energy + natGas; 
    }
    let perc = (energy)/income * 100; 
    setBurden(perc.toFixed(2))
  }
}

  const goBack = () => {
    setBurden(0); 
    setName(""); 
    setEmail("");
    setIncome(0); 
    setnatGas(0); 
    setoFuel(0); 
    setelectricity(0); 
    setMonthly(true); 
    setinvalidEmail(""); 
    setFill(""); 
    setnotNum("");  
  }

  return (
    <div className="App">
      <div className='body'>
      <div className="head1"> 
    <img className="logo" src={logo} alt="energy graphic"></img> 
    <span className="title">Energy Burden Calculator</span>
      </div>
      {burden===0? <div>
     <div className="body">
      <div className="EBDef">
        <div className="centerFloat">
      <span className="title2">What is Energy Burden?</span></div>
      <div className="centerFloat">
      <span className="eBExplain">Energy burden is the amount of your income you spend on home energy costs.</span>
      </div></div>
      <div className="calcEB"> 
      <div className="centerFloat">
      </div>
      <div className='centerFloat2'>
      <span className="calcHead">Calculate your energy burden</span></div>
      <div className="head2">
    <span className="subtitle">Figure out how much of your income goes to paying for energy.</span>
      </div>
      <form autoComplete='off'>
      <div className="inputSec">
        <div className="inpBlock">
         <span className="inpLabel">Your Name*</span>
        <input className="input" autocomplete="new-password" onChange={changeName} name="Name" type="text" placeholder="Name"></input>
        <span className="inpLabel">Email*</span>
        <input className="input" autocomplete="new-password" onChange={changeEmail} name="Email" type="text" placeholder="Email Address"></input>
        <span className='error'>{invalidEmail}</span>
        </div>
        <div className="inpBlock">
        <span className="inpLabel">Annual Household Income*</span>
        <input className="input" autocomplete="new-password" onChange={changeIncome} name="income" type="text" placeholder="$"></input>
        <span className="inpLabel">Energy Bills*</span>
        <span className="inpSub">What do you pay for electricity?</span>
        <input className="input" autocomplete="new-password" onChange={changeeectricity} name="enBill" type="text" placeholder="$"></input>
        <select className="select" onChange={changeMonthly1}>
          <option>Monthly</option>
          <option>Annually</option>
        </select>
        <span className="inpSub">What do you pay for natural gas?</span>
        <input className="input"  autocomplete="new-password" onChange={changenatGas} name="enBill" type="text" placeholder="$"></input>
        <select className="select" onChange={changeMonthly2}>
          <option>Monthly</option>
          <option>Annually</option>
        </select>
        <span className="inpSub">What do you pay for home heating fuel (propane, fuel oil, or kerosene)?</span>
        <input className="input" autocomplete="new-password" onChange={changeoFuel} name="enBill" type="text" placeholder="$"></input>
        <select className="select" onChange={changeMonthly}>
          <option>Monthly</option>
          <option>Annually</option>
        </select>
        <span className='error'>{notNum}</span>
        <span className='error'>{fill}</span>
        <div className="right">
          <button onClick={submitVal}   type="button" className="submit">Calculate</button>
        </div>
        </div>
      </div></form>
      </div></div></div> : null}
      {burden < 6 & burden !== 0? <div className='body'>
    <button className="backButton" onClick={goBack}>Back to calculator</button>
    <div className="resultOuter">
    <span className="resHead">You are not experiencing energy burden.</span>
  <div className='center'>
    <span className="spendText">You spend about </span>
    <span className="spendNum">{burden}%</span>
    <span className="spendText"> of your annual income on energy.</span></div>
    <div className="centerFloat2">
    <div className="resultOuter">
<span className="explainText">Unfortunately, that is not the case for many in our community. Look below to see what energy burden looks like across our community.</span>
<div className="centerFloat2">
<img className="statGraph" src={burdenStats} alt="energy graphic"></img></div></div>
   </div> </div>
    <div className='resultOuter'> 
<span className="resHead">Here's what you can do to help alleviate energy burden in our community.</span>
<div className='centerFloat2'>
<a href="https://theclimatecollaborative.org/uncovering-energy-inequity" type="button" className="learn">Learn More about Energy Burden</a>
</div>
</div>
      </div>: null}
      {burden >=6 & burden <10 & burden !== 0? <div>
        <button className="backButton" onClick={goBack}>Back to calculator</button>
      <div className="resultOuter">
        <span className="resHead">Your energy burden is high.</span>
        <div className='center'>
    <span className="spendText">You spend about </span>
    <span className="spendNum">{burden}%</span>
    <span className="spendText"> of your annual income on energy.</span></div>
    <div className="centerFloat2">
      <div className="resultOuter">
<span className="explainText">Check out how you compare to others across our community.</span>
<div className="centerFloat2">
<img className="statGraph" src={burdenStats} alt="energy graphic"></img></div>
     </div> </div>
      <div className='resultOuter'> 
<span className="resHead">Please reach out to C3 to find out information and resources for saving energy at home!</span>
<div className='centerFloat2'>
<a href="https://theclimatecollaborative.org/energy-clinics" type="button" className="learn">Learn More about Energy Burden</a>
</div></div>
      </div>
      </div>: null}
      {burden >=10 & burden <20 & burden !== 0? <div>
        <button className="backButton" onClick={goBack}>Back to calculator</button>
      <div className="resultOuter">
        <span className="resHead">Your energy burden is very high.</span>
        <div className='center'>
    <span className="spendText">You spend about </span>
    <span className="spendNum">{burden}%</span>
    <span className="spendText"> of your annual income on energy.</span></div>
    <div className="centerFloat2">
      <div className="resultOuter">
<span className="explainText">You're not alone. Here's what energy burden looks like in Charlottesville:</span>
<div className="centerFloat2">
<img className="statGraph" src={vHigh} alt="energy graphic"></img></div>
      </div></div>
      <div className='resultOuter'> 
<span className="resHead">Please reach out to C3 to find out information and resources for saving energy at home!</span>
<div className='centerFloat2'>
<a href="https://theclimatecollaborative.org/energy-clinics" type="button" className="learn">Learn More about Energy Burden</a>
</div></div>
      </div>
      </div>: null}
      {burden >=20 & burden !== 0? <div>
        <button className="backButton" onClick={goBack}>Back to calculator</button>
      <div className="resultOuter">
        <span className="resHead">Your energy burden is extremely high.</span>
        <div className='center'>
    <span className="spendText">You spend about </span>
    <span className="spendNum">{burden}%</span>
    <span className="spendText"> of your annual income on energy.</span></div>
    <div className="centerFloat2">
      <div className="resultOuter">
<span className="explainText">You're not alone. Here's what energy burden looks like in Charlottesville:</span>
<div className="centerFloat2">
<img className="statGraph" src={exHigh} alt="energy graphic"></img></div></div>
      </div>
      <div className='resultOuter'> 
<span className="resHead">Please reach out to C3 to find out information and resources for saving energy at home!</span>
<div className='centerFloat2'><a href="https://theclimatecollaborative.org/energy-clinics" type="button" className="learn">Learn More about Energy Burden</a>
</div>
</div>
      </div>
      </div>: null}
      </div>

    </div>
  );
}

export default App;
